import { NormalParallax } from 'mini-parallax'

const parallax = () => {
  const parallax = document.querySelectorAll('.parallax')
  const galleryParallax = document.querySelectorAll('.gallery-wrapper .parallax')

  if (parallax.length) {
    parallax.forEach(item => {
      new NormalParallax(item, {
        speed: -0.06
      })
    })
  }

  if (galleryParallax.length) {
    galleryParallax.forEach((item, index) => {
      if (index === 0) {
        new NormalParallax(item, {
          speed: -0.09
        })
      } else if (index === 1) {
        new NormalParallax(item, {
          speed: -0.06
        })
      } else if (index === 2) {
        new NormalParallax(item, {
          speed: -0.03
        })
      } else if (index === 3) {
        new NormalParallax(item, {
          speed: -0.09
        })
      }
    })
  }
}

parallax()